import React from "react";
import {HiOutlineMenuAlt4} from 'react-icons/hi';
import Logo from '../../../assets/trototLogo.png';
import { useNavigate } from 'react-router-dom';

const NavBar = () => {
    const navigate = useNavigate();

    const navigateToLogin = () => {
      // 👇️ navigate programmatically
      navigate('/login');
    };
    return(
        <div className="flex w-full justify-between items-center h-20 px-4 mt-4 absolute z-10 text-white">
            <div className="h-full mt-10 ml-10">
                <img className="h-full w-full" src={Logo} alt="/" />
            </div>  
            <ul className="hidden md:flex items-center">
                {/* <li className="mr-10"><a href="/">About us</a></li>
                <li className="mr-10"><a href="/">Contact</a></li> */}
                <div className="mr-8">
                <button className=" bg-[#6F977F] px-8 py-2 text-white rounded-md" onClick={navigateToLogin}>Đăng nhập</button>
                </div>
            </ul>
            <div className="md:hidden">
                <HiOutlineMenuAlt4 size={20} />
            </div>
        </div>
    )
}


export default NavBar;